"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedsAndDemandsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var CollapseHtmlWithInfoIconWidget_1 = require("../../../components/CollapseHtmlWithInfoIconWidget");
var NeedsAndDemandsWidget = /** @class */ (function (_super) {
    __extends(NeedsAndDemandsWidget, _super);
    function NeedsAndDemandsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setDrivingMoreThanOnePlaceOfWork = function (event) {
            var state = event.target.value === "false";
            _this.setState({ isDrivingMoreThanOnePlaceOfWork: state });
            _this.props.engine.setJourneyState({ isDrivingMoreThanOnePlaceOfWork: true });
        };
        _this.setKnowingPriceForYear = function (event) {
            var state = event.target.value === "false";
            _this.setState({ isKnowingPriceForYear: state });
            _this.props.engine.setJourneyState({ isKnowingPriceForYear: true });
        };
        _this.setEarningNoClaimDiscount = function (event) {
            var state = event.target.value === "false";
            _this.setState({ isEarningNoClaimDiscount: state });
            _this.props.engine.setJourneyState({ isEarningNoClaimDiscount: true });
        };
        _this.drivingMoreThanOnePlaceOfWorkCallback = function (infoState) {
            _this.setState({ showDrivingMoreThanOnePlaceOfWorkInfo: infoState });
        };
        _this.knowingPriceForYearCallback = function (infoState) {
            _this.setState({ showKnowingPriceForYearInfo: infoState });
        };
        _this.earningNoClaimDiscountCallback = function (infoState) {
            _this.setState({ showEarningNoClaimDiscountInfo: infoState });
        };
        _this.lvFlowWarningHeaderText = "Flow probably isn't the right choice for you";
        _this.state = {
            isDrivingMoreThanOnePlaceOfWork: props.engine.getJourneyState().isDrivingMoreThanOnePlaceOfWork || false,
            isKnowingPriceForYear: props.engine.getJourneyState().isKnowingPriceForYear || false,
            isEarningNoClaimDiscount: props.engine.getJourneyState().isEarningNoClaimDiscount || false,
            showDrivingMoreThanOnePlaceOfWorkWarning: false,
            showKnowingPriceForYearWarning: false,
            showEarningNoClaimDiscountWarning: false,
            showDrivingMoreThanOnePlaceOfWorkInfo: false,
            showKnowingPriceForYearInfo: false,
            showEarningNoClaimDiscountInfo: false
        };
        _this.showHideDrivingMoreThanOnePlaceOfWorkWarning = _this.showHideDrivingMoreThanOnePlaceOfWorkWarning.bind(_this);
        _this.showHideKnowingPriceForYearWarning = _this.showHideKnowingPriceForYearWarning.bind(_this);
        _this.showHideEarningNoClaimDiscountWarning = _this.showHideEarningNoClaimDiscountWarning.bind(_this);
        return _this;
    }
    NeedsAndDemandsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderContent(),
            this.continueButton(),
            this.state.showDrivingMoreThanOnePlaceOfWorkWarning && this.renderDrivingMoreThanOnePlaceOfWorkWarning(),
            this.state.showKnowingPriceForYearWarning && this.renderKnowingPriceForYearWarning(),
            this.state.showEarningNoClaimDiscountWarning && this.renderEarningNoClaimDiscountWarning()));
    };
    NeedsAndDemandsWidget.prototype.renderDrivingMoreThanOnePlaceOfWorkCollapseLabel = function () {
        var headerElement = React.createElement("label", { className: "ml-2" },
            React.createElement("b", null, "Flow"),
            " gives you ",
            React.createElement("b", null,
                "cover for social, domestic and pleasure use - as well ",
                ' ',
                "as commuting to one permanent place of work."),
            " Is this okay?");
        var contentElement = React.createElement("div", { className: "card col-md-6 shadow-none" },
            React.createElement("div", { className: "card-body" },
                React.createElement("p", { className: "card-text" },
                    "Flow gives you cover for social, domestic ",
                    ' ',
                    "and pleasure use - as well as commuting to one permanent place of work.",
                    React.createElement("br", null),
                    React.createElement("b", null, "If you work at different offices, or places"),
                    " and need to use your car to ",
                    ' ',
                    "travel to them, ",
                    React.createElement("b", null, "this won't be covered under a Flow subscription."))));
        return (React.createElement("div", { className: "needs-and-demands-collapse-label-widget" },
            React.createElement(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { header: headerElement, content: contentElement, parentCallback: this.drivingMoreThanOnePlaceOfWorkCallback })));
    };
    NeedsAndDemandsWidget.prototype.renderKnowingPriceForYearCollapseLabel = function () {
        var headerElement = React.createElement("label", { className: "ml-2" },
            React.createElement("b", null, "Flow gives you flexible payments"),
            ", which means ",
            React.createElement("b", null,
                "your monthly price ",
                ' ',
                "could vary"),
            ". Is this okay?");
        var contentElement = React.createElement("div", { className: "card col-md-6 shadow-none" },
            React.createElement("div", { className: "card-body" },
                React.createElement("p", { className: "card-text" },
                    "Instead of giving you a fixed price every month, we give you a maximum price every three ",
                    ' ',
                    "months. You'll find out what your exact monthly price will be in your account seven days ",
                    ' ',
                    "before we take payment - and we'll email you, too.",
                    React.createElement("br", null),
                    React.createElement("b", null, "As Flow is a subscription, we'll take payment from your credit or debit card every month."))));
        return (React.createElement("div", { className: "needs-and-demands-collapse-label-widget" },
            React.createElement(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { header: headerElement, content: contentElement, parentCallback: this.knowingPriceForYearCallback })));
    };
    NeedsAndDemandsWidget.prototype.renderEarningNoClaimDiscountCollapseLabel = function () {
        var headerElement = React.createElement("label", { className: "ml-2" },
            "Flow gives you our best price based on your current circumstances - ",
            React.createElement("b", null,
                "you ",
                ' ',
                "won\u2019t use or earn NCD"),
            ". Is this okay?");
        var contentElement = React.createElement("div", { className: "card col-md-6 shadow-none" },
            React.createElement("div", { className: "card-body" },
                React.createElement("p", { className: "card-text" },
                    "We\u2019re simplifying insurance, so ",
                    React.createElement("b", null, "we don\u2019t ask you for NCD years"),
                    " and ",
                    React.createElement("b", null,
                        "we don\u2019t sell ",
                        ' ',
                        "NCD protection"),
                    ". Instead, we\u2019ll offer you our best possible price based on the ",
                    ' ',
                    "information you give us.",
                    React.createElement("br", null),
                    "Although you won't earn NCD, ",
                    React.createElement("b", null,
                        "if you cancel your subscription we\u2019ll give you written ",
                        ' ',
                        "confirmation of any claim-free years with Flow"),
                    " (if you ask for one), although we can\u2019t ",
                    ' ',
                    "guarantee that another insurer will accept this as proof of NCD.")));
        return (React.createElement("div", { className: "needs-and-demands-collapse-label-widget" },
            React.createElement(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { header: headerElement, content: contentElement, parentCallback: this.earningNoClaimDiscountCallback })));
    };
    NeedsAndDemandsWidget.prototype.continueButton = function () {
        var continueButton = document.getElementsByClassName("btn btn-primary btn-next-arrow-separate").item(0);
        if (continueButton) {
            !this.isFormValid() ? continueButton.disabled = true : continueButton.disabled = false;
        }
    };
    NeedsAndDemandsWidget.prototype.renderContent = function () {
        return (React.createElement("div", { className: "panel" },
            React.createElement("div", { className: this.state.showDrivingMoreThanOnePlaceOfWorkInfo ? "background-color-grey inner-content negative-margin" : "" },
                this.renderDrivingMoreThanOnePlaceOfWorkCollapseLabel(),
                React.createElement("div", { className: "input-group input-group-radio", role: "group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "drivingMoreThanOnePlace-true", className: "custom-control-input null", type: "radio", name: "drivingMoreThanOnePlaceOfWork-true", value: "false", checked: this.state.isDrivingMoreThanOnePlaceOfWork, onChange: this.setDrivingMoreThanOnePlaceOfWork }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "drivingMoreThanOnePlace-true" }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "drivingMoreThanOnePlace-false", className: "custom-control-input null", type: "radio", name: "drivingMoreThanOnePlaceOfWork-false", value: "true", checked: false, onClick: this.showHideDrivingMoreThanOnePlaceOfWorkWarning }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "drivingMoreThanOnePlace-false" }, "No")))),
            React.createElement("div", { className: this.state.showKnowingPriceForYearInfo ? "background-color-grey inner-content negative-margin" : "" },
                this.renderKnowingPriceForYearCollapseLabel(),
                React.createElement("div", { className: "input-group input-group-radio", role: "group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "knowingPriceForYear-true", className: "custom-control-input null", type: "radio", name: "knowingPriceForYearAndPayingDirectDebit-true", value: "false", checked: this.state.isKnowingPriceForYear, onChange: this.setKnowingPriceForYear }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "knowingPriceForYear-true" }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "knowingPriceForYear-false", className: "custom-control-input null", type: "radio", name: "knowingPriceForYearAndPayingDirectDebit-false", value: "true", checked: false, onClick: this.showHideKnowingPriceForYearWarning }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "knowingPriceForYear-false" }, "No")))),
            React.createElement("div", { className: this.state.showEarningNoClaimDiscountInfo ? "background-color-grey inner-content negative-margin" : "" },
                this.renderEarningNoClaimDiscountCollapseLabel(),
                React.createElement("div", { className: "input-group input-group-radio", role: "group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "earningNoClaimDiscount-true", className: "custom-control-input null", type: "radio", name: "earningNoClaimDiscountNCD-true", value: "false", checked: this.state.isEarningNoClaimDiscount, onChange: this.setEarningNoClaimDiscount }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "earningNoClaimDiscount-true" }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "earningNoClaimDiscount-false", className: "custom-control-input null", type: "radio", name: "earningNoClaimDiscountNCD-false", value: "true", checked: false, onClick: this.showHideEarningNoClaimDiscountWarning }),
                        React.createElement("label", { className: "custom-control-label button-box-shadow", htmlFor: "earningNoClaimDiscount-false" }, "No"))))));
    };
    NeedsAndDemandsWidget.prototype.renderDrivingMoreThanOnePlaceOfWorkWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.showHideDrivingMoreThanOnePlaceOfWorkWarning, "aria-label": "Close dialog", role: "button" });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showDrivingMoreThanOnePlaceOfWorkWarning, toggle: this.showHideDrivingMoreThanOnePlaceOfWorkWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.showHideDrivingMoreThanOnePlaceOfWorkWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "warning-sign", src: "/img/alert-grey-blue.svg", alt: "warning-sign" }),
                        React.createElement("p", { className: "modal-header-text" }, this.lvFlowWarningHeaderText))),
                React.createElement(reactstrap_1.ModalBody, { className: "needs-and-demands-text" },
                    "Flow covers social, domestic and pleasure use, as well as travelling to a single, permanent workplace. ",
                    ' ',
                    React.createElement("b", null, "If you use your vehicle for commercial purposes"),
                    " (deliveries, for example), ",
                    React.createElement("b", null,
                        "or you work at several ",
                        ' ',
                        "different places, it's best to get a traditional car insurance quote instead.")),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("div", { className: "modal-button-wrapper" },
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-primary btn-add", href: "/journey/show/product/AnnualMotorInsurance/process/nb" }, "OK, take me to annual car policy")),
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-white", onClick: this.showHideDrivingMoreThanOnePlaceOfWorkWarning }, "Cancel")))))));
    };
    NeedsAndDemandsWidget.prototype.renderKnowingPriceForYearWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.showHideKnowingPriceForYearWarning, "aria-label": "Close dialog", role: "button" });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showKnowingPriceForYearWarning, toggle: this.showHideKnowingPriceForYearWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.showHideKnowingPriceForYearWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "warning-sign", src: "/img/alert-grey-blue.svg", alt: "warning-sign" }),
                        React.createElement("p", { className: "modal-header-text" }, this.lvFlowWarningHeaderText))),
                React.createElement(reactstrap_1.ModalBody, { className: "needs-and-demands-text" },
                    "We calculate your price every three months based on your current circumstances and then tell you the ",
                    ' ',
                    "maximum price you'll pay for that period. This may not always be the same amount. ",
                    ' ',
                    "And as ",
                    React.createElement("b", null, "Flow is a subscription, we take payment from your credit or debit card every month.")),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("div", { className: "modal-button-wrapper" },
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-primary btn-add", href: "/journey/show/product/AnnualMotorInsurance/process/nb" }, "OK, take me to annual car policy")),
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-white", onClick: this.showHideKnowingPriceForYearWarning }, "Cancel")))))));
    };
    NeedsAndDemandsWidget.prototype.renderEarningNoClaimDiscountWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.showHideEarningNoClaimDiscountWarning, "aria-label": "Close dialog", role: "button" });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showEarningNoClaimDiscountWarning, toggle: this.showHideEarningNoClaimDiscountWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.showHideEarningNoClaimDiscountWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "warning-sign", src: "/img/alert-grey-blue.svg", alt: "warning-sign" }),
                        React.createElement("p", { className: "modal-header-text" }, this.lvFlowWarningHeaderText))),
                React.createElement(reactstrap_1.ModalBody, { className: "needs-and-demands-text" },
                    "as ",
                    React.createElement("b", null, "we don't use NCD in calculating the price of cover and we don't sell any NCD protection."),
                    ' ',
                    "You also wouldn't be able to build up your entitlement through your Flow subscription."),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("div", { className: "modal-button-wrapper" },
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-primary btn-add", href: "/journey/show/product/AnnualMotorInsurance/process/nb" }, "OK, take me to annual car policy")),
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { color: "btn btn-white", onClick: this.showHideEarningNoClaimDiscountWarning }, "Cancel")))))));
    };
    NeedsAndDemandsWidget.prototype.showHideDrivingMoreThanOnePlaceOfWorkWarning = function () {
        this.setState({ showDrivingMoreThanOnePlaceOfWorkWarning: !this.state.showDrivingMoreThanOnePlaceOfWorkWarning });
    };
    NeedsAndDemandsWidget.prototype.showHideKnowingPriceForYearWarning = function () {
        this.setState({ showKnowingPriceForYearWarning: !this.state.showKnowingPriceForYearWarning });
    };
    NeedsAndDemandsWidget.prototype.showHideEarningNoClaimDiscountWarning = function () {
        this.setState({ showEarningNoClaimDiscountWarning: !this.state.showEarningNoClaimDiscountWarning });
    };
    NeedsAndDemandsWidget.prototype.isFormValid = function () {
        return (this.state.isDrivingMoreThanOnePlaceOfWork && this.state.isKnowingPriceForYear && this.state.isEarningNoClaimDiscount);
    };
    ;
    return NeedsAndDemandsWidget;
}(plugin_journey_1.WidgetBase));
exports.NeedsAndDemandsWidget = NeedsAndDemandsWidget;
//# sourceMappingURL=NeedsAndDemandsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/NeedsAndDemandsWidget.js
// module id = 2605
// module chunks = 0